import React, { useState } from 'react';
import { Box, Button, VStack, Heading, Span, Text } from '@bpba/ui-components';
import { SubmitHandler, useForm, Controller  } from "react-hook-form";
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { PaqueteBancaIndividuoSP } from '../rest/models/PaqueteBancaIndividuoSP';
import { Localidad } from '../rest/models/Localidad';
import { Queries } from '../rest/Queries';
import { useMutation, useQuery } from '@apollo/client';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { PaquetesBancaIndividuoSPApiRQ } from '../rest/models/PaquetesBancaIndividuoSPApiRQ';
import { postPaquetesBancaIndividuoSP } from '../rest/mutations/postPaquetesBancaIndividuoSP';
import { Mutations } from '../rest/Mutations';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { PAQUETES_BANCA_INDIVIDUO } from '../Constantes';
import ComboSucursales from "./ComboSucursales";
import { useNavigate } from 'react-router-dom';


export const PaquetesBancaIndividuoComponente: React.FC = () => {

    const { register, handleSubmit, control, formState: { errors }, reset } = useForm<PaqueteBancaIndividuoSP>({ mode: 'onChange',
     criteriaMode: 'all', reValidateMode: 'onChange',
     defaultValues: {
         sucursal: ""
 
     } });
    const REQUIRED_FIELD = "Campo requerido.";
    const numberValidator = /^\d+$/;
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const navigate = useNavigate();
    const [adjuntar, setAdjuntar] = useState(false);
    const [nroSolicitud, setNroSolicitud] = useState(0);
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const { data: { localidades } = {}} = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const [postPaquetesBancaIndividuoAPI, { loading: loadingMutation }] = useMutation<Mutations>(postPaquetesBancaIndividuoSP);

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>();
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");

    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }
    

    const onSubmit: SubmitHandler<PaqueteBancaIndividuoSP> = async (data: PaqueteBancaIndividuoSP) => {

        if (data.tipoIngreso === "6") {
            setServicioOk(true);
            setMensajeRtaServicio("no puede acceder al producto");
        } else {
            const token = executeRecaptcha && (await executeRecaptcha('PaquetesBancaIndividuo'));
            let datos: PaquetesBancaIndividuoSPApiRQ = {
                "googleToken": token,
                "razonSocial": data.nombreyApellido,
                "cuit": data.cuit.toString(),
                "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
                "localidad": data.provincia.split('-')[1] + "," + data.localidad + "," + data.calle + " " + data.numeroCalle + "," + data.piso,
                "email": data.email,
                "sucursal": Number.parseInt((data.sucursal === "0" ? "1000" : data.sucursal)),
                "condicionImpositiva": data.tipoIngreso,
                "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud
            };
            await postPaquetesBancaIndividuoAPI({ variables: { input: datos } }).then((response: any) => {

                if (response !== null || response !== undefined) {
                    setServicioOk(true);
                    if (response.data.PaquetesBancaIndividuoSPApiRQ.resultado === "ok") {

                        setNroSolicitud(response.data?.PaquetesBancaIndividuoSPApiRQ.nroSolicitud)
                        setAdjuntar(true)
                        setMensajeRtaServicio(<><Text fontSize={"20px"} margin={0} fontWeight={600}>A través de la opción “Adjuntar", podés enviar copia digitalizada de la documentación solicitada.</Text><Text fontSize={"16px"} margin={0}>Podrás cargar los siguientes formatos : image/gif, image/jpg, image/jpeg, image/png, txt, csv, bmp, tiff, pdf, docx  (tamaño máximo 1MB).</Text></>);

                    } else if (response.data.PaquetesBancaIndividuoSPApiRQ.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())) {
                        
                        setMensajeRtaServicio(response.data.PaquetesBancaIndividuoSPApiRQ.error);

                    } else {
                        
                        setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                    }
                } else {

                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");

                }


            }).catch(() => {

                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            });

        }


    }

    const handleReset = () => {
        reset({});
        window.location.reload();
    };

    const handleRedirect = () => {
        navigate('/DocumentacionAdjunta', {
            state: {
                nroSolicitud: nroSolicitud,
                banner: PAQUETES_BANCA_INDIVIDUO,
                titulo: "Paquetes Banca Individuo",
                masDeUnArchivo: true
            }
        });
    };

    if (adjuntar) return (
        <VStack>
            <VStack>
                <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => {setAdjuntar(false); setServicioOk(true); setMensajeRtaServicio("En los próximos días nos contactaremos con vos."); }}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Finalizar
                        </Button>
                    </VStack>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleRedirect()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%", backgroundColor: "white",
                                borderRadius: "3px 8px 3px 8px",
                                border: "solid 2px", borderColor: "#3c3c3b",
                                color: "#3c3c3b",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Adjuntar
                        </Button>
                    </VStack>
                </VStack>
            </VStack>

        </VStack>
    );

    if (loadingMutation) return <SpinnerCajas />;
    if (servicioOk) return (
        <Result handleReset={handleReset}>
             <VStack>
                <Heading level={2} fontWeight={400} children={mensajeRtaServicio} color="primary.0" tabIndex={0} />
            </VStack>
      
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>

    );


    return (<>
        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    <VStack mt={"20px"}>
                        <input {...register(`nombreyApellido`, { required: REQUIRED_FIELD, maxLength: 50 })} name='nombreyApellido' type={"text"} placeholder='Nombre y Apellido' maxLength={50}/>
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombreyApellido ? "* " + errors.nombreyApellido.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register(`cuit`, { required: REQUIRED_FIELD,minLength:{value:11, message:"Debe tener al menos 11 dígitos"}, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' placeholder='CUIT/CUIL' type={"text"}  />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, maxLength: 100, pattern: { value: mailValidator, message: "Formato del correo electrónico inválido ejemplo: juana@mail.com" } })} name="email" placeholder='Correo electrónico' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} mb={"8px"} style={{ lineHeight: "18px" }}>
                            Teléfono de contacto
                        </Span>
                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Área: ejemplo 011' maxLength={4} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Número' maxLength={14} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                            </VStack>
                        </VStack>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Localidad</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                    style={{ width: "100%" }}
                                    {...register("provincia", { required: REQUIRED_FIELD })}
                                    onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                    <option value="">Ubicación</option>
                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia ? "* " + errors.provincia.message : ""}</Span>
                            </VStack>
                            <VStack >
                                <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad' >
                                    <option value="" selected >Localidad/barrio</option>
                                    {localidades &&
                                        localidades.map((item: Localidad) =>
                                            <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad ? "* " + errors.localidad.message : ""}</Span>
                            </VStack>
                        </VStack>


                        <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle ? "* " + errors.calle.message : ""}</Span>
                            </VStack>
                            <VStack mr={"0.5rem"}>
                                <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Número' maxLength={5} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle ? "* " + errors.numeroCalle.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0}{...register("piso", { required: false, maxLength: 8 })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                            </VStack>

                        </VStack>

                    </VStack>
                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Por favor, seleccioná tu tipo de ingresos</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack>
                                <select tabIndex={0} aria-label={"Por favor, seleccioná tu tipo de ingreso"}
                                    style={{ width: "100%" }}
                                    {...register("tipoIngreso", { required: REQUIRED_FIELD })}
                                    name="tipoIngreso" placeholder='tipoIngreso' >
                                    <option value="">Seleccione datos tributarios</option>
                                    <option value="1">Relación de Dependencia</option>
                                    <option value="2">Monotributista</option>
                                    <option value="3">Responsable inscripto</option>
                                    <option value="5">Jubilado/a</option>
                                    <option value="6">No puedo demostrar ingresos</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.tipoIngreso ? "* " + errors.tipoIngreso.message : ""}</Span>
                            </VStack>

                        </VStack>

                    </VStack>
                   
                    <Controller
                                control={control}
                                name="sucursal"
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return <ComboSucursales {...field} onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal donde quéres finalizar el tramite"} sucursalCliente={undefined} />
                                }}
                            />

                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.sucursal?.message}</Span>
                         



                     
                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>


                </form>
            </VStack>

        </Box>

        
    </>
    );
}
